import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { MenuVotePage } from './pages/menu-vote';
import { MenuVoteResultPage } from './pages/menu-vote-result';
import { PromoLayout } from './pages/promo-layout';
import { AppFrame, AppShell } from './App.styles';

function App() {
  return (
    <AppShell>
      <AppFrame>
        <BrowserRouter>
          <Routes>
            <Route element={<PromoLayout />}>
              <Route path="/" element={<MenuVotePage />} />
              <Route path="/result" element={<MenuVoteResultPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AppFrame>
    </AppShell>
  );
}

export default App;
